import { ScaleElement } from '@scale/base-element';

class ScaleBackToTop extends ScaleElement {
  #lastScrollY = 0;
  #scrollDirection = 'up';
  #frame = 0;

  setup() {
    this.on('click', this.#scrollToTop);
    window.addEventListener('scroll', this.#onScroll, { passive: true, signal: this.signal });
    this.#onScroll();
  }

  teardown() {
    cancelAnimationFrame(this.#frame);
    this.#frame = 0;
  }

  #onScroll = () => {
    if (this.#frame) return;
    this.#frame = requestAnimationFrame(() => {
      this.#frame = 0;
      this.#update();
    });
  };

  #update() {
    const scrollY = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    if (docHeight <= 0) return;

    const percent = (scrollY / docHeight) * 100;
    const threshold = this.getNumber('threshold', 30);

    const delta = scrollY - this.#lastScrollY;
    if (Math.abs(delta) > 5) {
      this.#scrollDirection = delta > 0 ? 'down' : 'up';
    }
    this.#lastScrollY = scrollY;

    const pastThreshold = percent >= threshold;
    const hideDown = this.getBoolean('hide-on-scroll-down') && this.#scrollDirection === 'down' && scrollY > 100;

    this.classList.toggle('is-visible', pastThreshold && !hideDown);
    this.classList.toggle('is-hidden', pastThreshold && hideDown);
  }

  #scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
}

if (!customElements.get('scale-back-to-top')) {
  customElements.define('scale-back-to-top', ScaleBackToTop);
}
